import API_END_POINTS from '../../../api/endpoints';
import { dataFetch } from '../../../api/data-fetch';
import moment from 'moment';
// initial state
const state = () => ({
  meetingData: null,
  meetingsData: null,
});

// actions
const actions = {
  async fetchMeetingData({ commit }, { slug, startDate, endDate, fetcher = dataFetch }) {
    try {
      // get meeting by slug
      const meetingBySlugEndpoint = `${API_END_POINTS.HARNESS.MEETING}${slug}?include=events`;
      const meetingResponse = await fetcher(meetingBySlugEndpoint);
      // set event data
      const meetingData = meetingResponse.data.meeting;
      commit('SET_MEETING_DATA', { meetingData });

      try {
        // get upcoming meetings and format for dropdowns, Ex. Wednesday, June 26th
        const meetingsByDateEndpoint = `${
          API_END_POINTS.HARNESS.BY_MEETINGS_DATE
        }?startDate=${startDate}&endDate=${endDate}`;
        const meetingsResponse = await fetcher(meetingsByDateEndpoint);
        const meetingsData = meetingsResponse.data.meetings.reduce((object, meeting) => {
          object[moment(meeting.meeting_date_utc).format('dddd, MMMM Do')] = (
            object[moment(meeting.meeting_date_utc).format('dddd, MMMM Do')] || []
          ).concat(meeting);
          return object;
        }, {});

        commit('SET_MEETINGS_DATA', meetingsData);
      } catch (err) {
        console.log(err);
      }
    } catch (error) {
      console.log(error);
    }
  },
};

// mutations
const mutations = {
  SET_MEETING_DATA: (state, { meetingData }) => {
    state.meetingData = meetingData;
  },
  SET_MEETINGS_DATA: (state, meetingsData) => {
    state.meetingsData = meetingsData;
  },
};

// getter
const getters = {
  getMeetingData: state => {
    return state.meetingData;
  },
  getMeetingsData: state => {
    return state.meetingsData;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
